import { render } from "./SpeechPlayer.vue?vue&type=template&id=0cedac41"
import script from "./SpeechPlayer.vue?vue&type=script&lang=js"
export * from "./SpeechPlayer.vue?vue&type=script&lang=js"

import "./SpeechPlayer.vue?vue&type=style&index=0&id=0cedac41&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__